"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactQuery = require("react-query");
var _core = require("@folio/stripes/core");
var _utils = require("../utils");
var _endpoints = require("../constants/endpoints");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useModConfigEntries = _ref => {
  let {
    configName,
    moduleName,
    namespaceAppend,
    queryParams
  } = _ref;
  const ky = (0, _core.useOkapiKy)();
  const query = `?query=(module=${moduleName} and configName=${configName})`;
  const path = `${_endpoints.MOD_SETTINGS_ENDPOINT}${query}`;
  const namespace = (0, _utils.modConfigEntriesQueryKey)({
    configName,
    moduleName,
    namespaceAppend
  });
  const queryObject = (0, _reactQuery.useQuery)(namespace, () => ky(path).json(), queryParams);
  const {
    data: {
      configs: {
        0: settings = {}
      } = []
    } = {}
  } = queryObject;
  const parsedSettings = (0, _utils.parseModConfigEntry)(settings);
  return {
    parsedSettings,
    queryObject,
    settings
  };
};
useModConfigEntries.propTypes = {
  moduleName: _propTypes.default.string,
  configName: _propTypes.default.string,
  queryParams: _propTypes.default.object
};
var _default = exports.default = useModConfigEntries;